import ImageCarousel from "../../Components/Common/Carousel";
import EstandeSemImagem from "../../assets/images/estande_sem_imagem.png";
import DimensoesTable from "../ComponenteCompartilhado/DimensoesTable";

import { useState } from 'react';

const SidebarEstandeVendidoNovo = ({
  selectedEstandeInfo,
  corPrincipal,
  corSecundaria,
  isMobile,
  setOpenMobile,
  label,
  onToggle,
  isOpen
}) => {
  const [imgError, setImgError] = useState(false);  
  const renderExpositorInfo = () => {
    if (!selectedEstandeInfo?.expositor || selectedEstandeInfo.expositor.length === 0) {
      return null;
    }

    const expositor = selectedEstandeInfo.expositor[0];
    // Simplificamos a lógica de redes + site
    const socialLinks = [
      { icon: "bx bxl-facebook", url: expositor.facebook },
      { icon: "bx bxl-instagram", url: expositor.instagram },
      { icon: "bx bxl-linkedin", url: expositor.linkedin },
      { icon: "bx bx-world", url: expositor.site || expositor.bluesky }, // Usando ícone para o site
    ].filter(link => link.url);

    return (
      <div style={{ 
        padding: "1rem", 
        borderRadius: "12px", 
        background: "rgba(255, 255, 255, 0.15)", // Leve transparência para dar profundidade
        backdropFilter: "blur(4px)",
        border: "1px solid rgba(255, 255, 255, 0.2)"
      }}>
        <div className="d-flex align-items-center">
          {/* {expositor.logoUrl && (
            <div className="flex-shrink-0" style={{
              background: "white",
              padding: "4px",
              borderRadius: "50%",
              boxShadow: "0 4px 8px rgba(0,0,0,0.1)"
            }}>
              <img 
                src={expositor.logoUrl} 
                alt={expositor.nome} 
                className="avatar-sm rounded-circle" 
                style={{ objectFit: "contain", width: "45px", height: "45px" }}
              />
            </div>
          )} */}

          {expositor.logoUrl && !imgError && (
            <div className="flex-shrink-0" style={{ background: "white", padding: "4px", borderRadius: "50%" }}>
              <img 
                src={expositor.logoUrl} 
                alt={expositor.nome} 
                className="avatar-sm rounded-circle" 
                style={{ objectFit: "contain", width: "45px", height: "45px" }}
                onError={() => setImgError(true)} 
              />
            </div>
          )}

          <div className="flex-grow-1 ms-3 text-start">
            <h5 className="mb-0 text-white" style={{ 
              fontSize: "15px", 
              lineHeight: "1.2",
              maxWidth: "200px" // Evita que o nome empurre tudo
            }}>
              {expositor.nome}
            </h5>
            <small style={{ color: "rgba(255,255,255,0.8)", fontSize: "11px" }}>Expositor Confirmado</small>
          </div>
        </div>

        {socialLinks.length > 0 && (
          <div className="d-flex justify-content-start gap-2 pt-2" style={{ borderTop: "1px solid rgba(255,255,255,0.1)" }}>
            {socialLinks.map((link, idx) => (
              <a 
                key={idx} 
                href={link.url} 
                target="_blank" 
                rel="noopener noreferrer"
                style={{
                  width: "32px",
                  height: "32px",
                  borderRadius: "8px",
                  background: "white",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  transition: "transform 0.2s"
                }}
                onMouseOver={(e) => e.currentTarget.style.transform = "scale(1.1)"}
                onMouseOut={(e) => e.currentTarget.style.transform = "scale(1)"}
              >
                <i className={link.icon} style={{ color: corPrincipal, fontSize: "18px" }}></i>
              </a>
            ))}
          </div>
        )}
      </div>
    );
  };

  return (
    <div style={{ "--primary-color": corPrincipal, "--second-color": corSecundaria }}>
    
      {!!onToggle && (
        <div className={`sidebar-backdrop ${isOpen ? "is-visible" : ""}`} onClick={onToggle} />
      )}

      
        <div className="sidebar-header">
          {isMobile && typeof setOpenMobile === "function" && (
            <button
              onClick={() => setOpenMobile(false)}
              style={{
                position: "absolute",
                top: 10,
                right: 10,
                background: "transparent",
                border: "none",
                fontSize: 26,
                color: "white",
                zIndex: 20,
              }}
              aria-label="Fechar"
              title="Fechar"
            >
              ×
            </button>
          )}
          
          <h4 style={{ color: 'white'}} >{selectedEstandeInfo?.nome || ""} {label}</h4>
          {selectedEstandeInfo?.pavilhao.length > 0 && (
            <span style={{ color: 'white'}}>{selectedEstandeInfo?.pavilhao[0].nome}</span>
          )}
              
          {renderExpositorInfo()}
        </div>

        <div className="sidebar-body">
          <ImageCarousel 
            images={selectedEstandeInfo?.imagens || []} 
            defaultImage={EstandeSemImagem}
            corFundo={corPrincipal}
          />
    
          {/* Dimensões do estande */}
          <DimensoesTable selectedEstandeInfo={selectedEstandeInfo} corPrincipal={corPrincipal} />
  
          {/* Mensagem de estande vendido */}
          <div style={{ 
            // padding: "1.5rem", 
            textAlign: "center",
            marginTop: "0.5rem"
          }}>
            <div style={{
              background: "#f8f9fa",
              padding: "1rem",
              borderRadius: "8px",
              border: `1px solid ${corPrincipal}`
            }}>
              <p style={{ 
                color: corPrincipal,
                fontWeight: "500",
                marginBottom: "0"
              }}>
                Este espaço já foi {label}.
              </p>
              {selectedEstandeInfo?.expositor?.[0]?.nome && (
                <p style={{ marginTop: "0.5rem", marginBottom: "0" }}>
                  Expositor: <strong>{selectedEstandeInfo.expositor[0].nome}</strong>
                </p>
              )}
            </div>   
          </div>
        </div>
   
    </div>
  );
};

export default SidebarEstandeVendidoNovo;